import { Box, MenuItem, Pagination, PaginationItem, Select, Typography } from "@mui/material";
import type { SelectChangeEvent } from "@mui/material";
import type { TranslateFn } from "../types";

type CatalogPaginationProps = {
  t: TranslateFn;
  loading: boolean;
  page: number;
  pageCount: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

const CatalogPagination = ({
  t,
  loading,
  page,
  pageCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: CatalogPaginationProps) => (
  <Box className="flex items-center justify-between mt-4">
    <Box className="flex items-center gap-2">
      <Typography className="text-[var(--sidebar-foreground)] text-xs font-normal">
        {t("common.rowsPerPage")}
      </Typography>
      <Select
        data-testid="ai-catalog-page-size-select"
        displayEmpty
        disabled={loading}
        value={String(pageSize)}
        onChange={(event: SelectChangeEvent<string>) =>
          onPageSizeChange(Number(event.target.value))
        }
      >
        {[10, 25, 50].map((size) => (
          <MenuItem
            key={size}
            data-testid={`ai-catalog-page-size-option-${size}`}
            value={String(size)}
          >
            {size}
          </MenuItem>
        ))}
      </Select>
    </Box>
    <Pagination
      data-testid="ai-catalog-pagination"
      count={pageCount}
      page={page}
      onChange={(_event, newPage) => onPageChange(newPage)}
      showFirstButton
      showLastButton
      renderItem={(item) => (
        <PaginationItem
          {...item}
          data-testid={`ai-catalog-pagination-${item.type}${
            item.page ? `-${item.page}` : ""
          }`}
        />
      )}
    />
  </Box>
);

export default CatalogPagination;
